import { Component, Input } from '@angular/core';
import { CommonFunctions } from '../../static/common-functions';

import { BaseMessageInfo } from '../../models/BaseMessageInfo';
import { DispatchesService } from '../../services/dispatches.service';
import { PersonContactBus } from '../../models/PersonContactBus';
import { ContactBus } from '../../models/ContactBus';

@Component({
    selector: 'person-contact',
    templateUrl: './person-contact.component.html',
    styleUrls: ['./person-contact.component.scss']
})
export class PersonContactComponent    {

    constructor( private svc_data: DispatchesService) {
    }
    @Input() set personId(id: any) {
        if (CommonFunctions.hasValue(id) && id !== this._personId) {
            this._personId = id;
            this.getData();
        }
    }
    protected _person: PersonContactBus;
    get contact(): ContactBus {
        return this._person ? this._person.person : new ContactBus(null);
    }
    get manager(): ContactBus {
        return this._person ? this._person.manager : new ContactBus(null);
    }
    protected _personId: any;
    getData() {
        this.svc_data.personContactInfo(this._personId).subscribe((info: BaseMessageInfo) => {
            this._person = new PersonContactBus(info.primaryReturn);
        });
    }
}

